module.exports = __webpack_public_path__ + "img/上汽通用五菱@2x.378435b5.png";